import classNames from 'classnames'
import { Icon } from '@vzmi/shp_shared_compo'
import 'flatpickr/dist/themes/light.css'
import ReactFlatpickr from 'react-flatpickr'
import styles from './YFlatpickr.css'

/** setup locale for flatpickr */
import flatpickr from 'flatpickr'
import { Mandarin } from 'flatpickr/dist/l10n/zh.js'
flatpickr.localize(Mandarin)

/**
 * Base on Flatpickr
 *
 * https://github.com/flatpickr/flatpickr
 * https://flatpickr.js.org/examples/
 */
export const Flatpickr = ReactFlatpickr

export default Flatpickr

// set allowInput as true to disable input to be clear when pressing backspace keydown
// ref: https://github.com/flatpickr/flatpickr/issues/1376
export const WrappedFlatpickr = ({
  className,
  name,
  clearable,
  enableCalender,
  onFlatpickrClear,
  placeholder,
  dateFormat,
  options = {},
  readOnly,
  ...restProps
}) => (
  <Flatpickr
    className={classNames(
      styles.WrappedFlatpickr,
      className,
      `${readOnly ? 'disable' : ''}`
    )}
    {...restProps}
    options={{
      ...options,
      allowInput: options.allowInput !== false,
      wrap: true,
      dateFormat: dateFormat || 'Y/m/d'
    }}
  >
    <input
      disabled={readOnly}
      readOnly={readOnly || !options.allowInput}
      type='text'
      name={name}
      placeholder={placeholder || '請選擇日期...'}
      data-input
    />
    {
      clearable && (
        <a
          className={styles.clearBtn}
          title='clear'
          onClick={onFlatpickrClear}
          data-clear
        >
          <Icon
            name='close'
            align='middle'
            size={16}
          />
        </a>
      )
    }
    {
      enableCalender && (
        <a
          className={styles.calenderBtn}
          data-role='calendar-button'
          data-toggle
        >
          <Icon
            name='calendar'
            size={18}
            align='middle'
          />
        </a>
      )
    }
  </Flatpickr>
)
